import React from "react";

export default function TickBoxes({ count = 4, value = 0, onChange, testKeyPrefix, color = "magenta", label }) {
  const boxes = Array.from({ length: count }, (_, i) => i);
  const activeCls = color === "magenta"
    ? "bg-[color:var(--accent-magenta)] border-[color:var(--accent-magenta)]"
    : "bg-[color:var(--accent-cyan)] border-[color:var(--accent-cyan)]";
  const idleCls = color === "magenta"
    ? "border-[color:var(--border-hard)] hover:border-[color:var(--accent-magenta)]"
    : "border-[color:var(--border-hard)] hover:border-[color:var(--accent-cyan)]";

  const set = (i, on) => {
    // Clicking a box toggles ALL boxes up to and including it
    // - If clicking a checked box that IS the highest checked -> uncheck it (value = i)
    // - Else -> check up to i (value = i + 1)
    const next = on ? i : i + 1;
    onChange(Math.max(0, Math.min(count, next)));
  };

  return (
    <div className="flex items-center gap-2 min-w-0" data-testid={`${testKeyPrefix}-group`}>
      {label && (
        <span className="text-[10px] font-mono uppercase tracking-widest text-[color:var(--text-muted)] mr-1">
          {label}
        </span>
      )}
      <div className="flex flex-wrap gap-1 min-w-0">
        {boxes.map((i) => {
          const isOn = i < value;
          return (
            <button
              key={i}
              type="button"
              aria-pressed={isOn}
              aria-label={`${label || "tick"} ${i + 1}`}
              data-testid={`${testKeyPrefix}-${i}`}
              onClick={() => set(i, isOn)}
              className={`w-6 h-6 border-2 flex items-center justify-center transition-colors ${isOn ? activeCls : idleCls}`}
            >
              {isOn && <span className="block w-2 h-2 bg-[color:var(--bg-void)]" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
